import { render, staticRenderFns } from "./category-edit.vue?vue&type=template&id=d4f8bc36"
import script from "./category-edit.vue?vue&type=script&lang=js"
export * from "./category-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports